import { customFetch } from '../utils/custom-fetch';
import { redirect } from 'react-router-dom';
import { toast } from 'react-toastify';

export async function action({ params }) {
  try {
    await customFetch.delete(`/buildings/${params.id}`);
    toast.success('Job building successfully');
  } catch (error) {
    toast.error(error.response.data.msg);
  }
  return redirect('/dashboard/all-buildings');
}

const DeleteBuilding = () => {
  return <h1>Delete Page</h1>;
};

export default DeleteBuilding;
